import axios from '../base/axios';
import API_KEY from './key';

const GET_TVACTIONANDADVENTURE = 'flixfrenzy/redux/GET_TVACTIONANDADVENTURE';

// eslint-disable-next-line default-param-last
const tvActionAndAdventureReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVACTIONANDADVENTURE:
      return action.payload;
    default:
      return state;
  }
};

export const getTvActionAndAdventure = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10759`).then((res) => {
    dispatch({
      type: GET_TVACTIONANDADVENTURE,
      payload: res.data,
    });
  });
};

export default tvActionAndAdventureReducer;
